import { STATUS } from '../../constants';
import { isTicketDriverListVisible } from '../ticket/canResolveTicket';

// Client callers receive server-filtered driverItems. Server callers pass the run driver when counting raw list items.
const isCountableItem = (ticketListItem, tenantSettings, serviceRunDriver) => (
	serviceRunDriver === undefined ||
	isTicketDriverListVisible(ticketListItem.ticket, tenantSettings, serviceRunDriver)
);

export const countDriverTickets = (ticketListItems, tenantSettings, serviceRunDriver) => {
	return ticketListItems.reduce((acc, ticketListItem) => {
		return acc + (isCountableItem(ticketListItem, tenantSettings, serviceRunDriver) ? 1 : 0);
	}, 0);
};

export const countDriverOpenTickets = (ticketListItems, tenantSettings, serviceRunDriver) => {
	return ticketListItems.reduce((acc, ticketListItem) => {
		return acc + (isCountableItem(ticketListItem, tenantSettings, serviceRunDriver) && (!ticketListItem.notResolved && ticketListItem.ticket.status === STATUS.OPEN) ? 1 : 0);
	}, 0);
};

export const countDriverResolvedTickets = (ticketListItems, tenantSettings, serviceRunDriver) => {
	return ticketListItems.reduce((acc, ticketListItem) => {
		return acc + (isCountableItem(ticketListItem, tenantSettings, serviceRunDriver) && (ticketListItem.notResolved || ticketListItem.ticket.status === STATUS.RESOLVED) ? 1 : 0);
	}, 0);
};
